/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Skip_To_Main_ContentInputs */

const en_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip to main content`)
};

const ar_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تخطَّ إلى المحتوى الرئيسي`)
};

const bn_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মূল কনটেন্টে যান`)
};

const de_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Hauptinhalt springen`)
};

const es_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al contenido principal`)
};

const fr_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller au contenu principal`)
};

const pt_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o conteúdo principal`)
};

const zh_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳到主要内容`)
};

const tr_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ana içeriğe atla`)
};

const ru_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к основному содержанию`)
};

const pl_skip_to_main_content = /** @type {(inputs: Skip_To_Main_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź do głównej treści`)
};

/**
* | output |
* | --- |
* | "Skip to main content" |
*
* @param {Skip_To_Main_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const skip_to_main_content = /** @type {((inputs?: Skip_To_Main_ContentInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Skip_To_Main_ContentInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_skip_to_main_content(inputs)
	if (locale === "bn") return bn_skip_to_main_content(inputs)
	if (locale === "de") return de_skip_to_main_content(inputs)
	if (locale === "es") return es_skip_to_main_content(inputs)
	if (locale === "fr") return fr_skip_to_main_content(inputs)
	if (locale === "pt") return pt_skip_to_main_content(inputs)
	if (locale === "zh") return zh_skip_to_main_content(inputs)
	if (locale === "tr") return tr_skip_to_main_content(inputs)
	if (locale === "ru") return ru_skip_to_main_content(inputs)
	if (locale === "pl") return pl_skip_to_main_content(inputs)
	return en_skip_to_main_content(inputs)
});